import * as React from 'react';

import type {ListOptionWithCount} from 'shells/select-option-components/option-with-count';

import {useGetAudiences} from './hooks/use-get-audiences';

type Props = {
    disablePublicAudiences?: boolean;
    excludeWebFXAudiences?: boolean;
    children: (arg1: ChildrenProps) => React.ReactElement;
    excludedAudienceIds?: string[];
};

type ChildrenProps = {
    options: ListOptionWithCount[];
    isLoading: boolean;
    refetch: () => Promise<any>;
};

export const GraphQLSelectAudiencesProvider = (props: Props) => {
    const {audiences, refetch, isLoading} = useGetAudiences({
        excludeWebFXAudiences: props.excludeWebFXAudiences,
    });

    // map over the list to get the proper value/label options to pass
    // through to the select component below
    let audienceOptions: ListOptionWithCount[] = audiences.map((node) => ({
        value: node.id,
        label: node.name,
        count: node.membershipStats.totalCount.value,
        isFx: node.isWebFX,
        isSyncing: node.isSyncing,
        isDisabled: props.disablePublicAudiences && node.isPublic,
    }));

    if (props.disablePublicAudiences) {
        // sort disabled to bottom
        audienceOptions.sort((a, b) => {
            return Number(a.isDisabled) - Number(b.isDisabled);
        });
    }

    if (props.excludedAudienceIds) {
        audienceOptions = audienceOptions.filter(
            (option) =>
                props.excludedAudienceIds && !props.excludedAudienceIds.includes(option.value)
        );
    }

    return props.children({
        options: audienceOptions,
        isLoading,
        refetch,
    });
};
